import {reportRegime} from "../../../infrastructure/constants/reportRegime";

const getAccuracyReportRawDataSource = (regime: string) => {

    switch (regime) {
        case reportRegime['MiFIR']: return 'CN_MiFIR';
        case reportRegime['EMIR']: return 'CN_EMIR';
        case reportRegime['REFIT']: return 'CN_REFIT';
        case reportRegime['MAS']: return 'CN_MAS';
        case reportRegime['ASIC']: return 'CN_ASIC';
        case reportRegime['MAS Rewrite']: return 'CN_MAS_Rewrite';
        case reportRegime['ASIC Rewrite']: return 'CN_ASIC_Rewrite';
        case reportRegime['OSC Rewrite']: return 'CN_OSC_Rewrite';
        case reportRegime['IIROC']: return 'CN_IIROC';
        case reportRegime['MiFIR Cb']: return 'CN_MiFIR_Cb';
        case reportRegime['MiFIR Cp']: return 'CN_MiFIR_Cp';
        case reportRegime['SIX Derivatives']: return 'CN_SIX_Derivatives';
        case reportRegime['SIX Securities']: return 'CN_SIX_Securities';
        case reportRegime['SFTR']: return 'CN_SFTR';
        case reportRegime['MiFIR Transparency']: return 'CN_MiFIR_Transparency';
        case reportRegime['CAT']: return 'CN_CAT';
        case reportRegime['REMIT']: return 'CN_REMIT';

        default: return '';
    }
}

let accuracyDataSourceFormHelper = {
    getAccuracyReportRawDataSource
}

export default accuracyDataSourceFormHelper;